import { defineComponent as _defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import { Combobox, ComboboxButton, ComboboxInput, ComboboxOption, ComboboxOptions, } from '@headlessui/vue';
import { useRoute, useRouter } from 'vue-router';
import { computed, ref, watch } from 'vue';
import { asArray } from '@/utils/utils';
import { ChevronDownIcon, MagnifyingGlassIcon, XMarkIcon } from '@heroicons/vue/20/solid';
export default /*@__PURE__*/ _defineComponent({
    __name: 'QueryWithSearchDropdown',
    props: {
        filterKey: { type: String, required: true },
        filterOptions: { type: Array, required: true },
        by: { type: String, required: false },
        multiple: { type: Boolean, required: false, default: false },
        disabled: { type: Boolean, required: false, default: false },
        placeholder: { type: String, required: false, default: '' },
        searchPlaceholder: { type: String, required: false, default: () => (useI18n().t('Type to filter…')) },
        defaultValue: { type: [Object, Array], required: false, default: null },
        pagination: { type: Boolean, required: false, default: false }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const { t: $t } = useI18n();
        const route = useRoute();
        const router = useRouter();
        const options = ref(__props.filterOptions);
        watch(() => __props.filterOptions, (newFilters) => {
            options.value = newFilters;
        });
        const query = ref('');
        const onInput = (event) => {
            query.value = event.target.value;
        };
        const filteredOptions = computed(() => query.value === ''
            ? options.value
            : options.value.filter((option) => option.label.toLowerCase().includes(query.value.toLowerCase())));
        const filteredDebouncedOptions = computed(() => {
            return filteredOptions.value.slice(0, limit.value);
        });
        let debounceInterval = null;
        let limit = ref(100);
        const isOpen = ref(false);
        const trackedOpenState = {
            open: null,
            closed: null,
        };
        function trackOpenState(open) {
            if (open) {
                trackedOpenState.open = selectedOptions.value;
                if (!debounceInterval) {
                    debounceInterval = setInterval(() => {
                        limit.value = limit.value + 50;
                        if (filteredDebouncedOptions.value.length >= options.value.length) {
                            limit.value = filteredDebouncedOptions.value.length;
                            clearInterval(debounceInterval);
                        }
                    }, 100);
                }
            }
            else {
                trackedOpenState.closed = selectedOptions.value;
                clearInterval(debounceInterval);
                debounceInterval = null;
                limit.value = 100;
            }
            if (isOpen.value !== open) {
                isOpen.value = open;
                if (!open) {
                    let newQuery = { ...route.query };
                    if (trackedOpenState.open === trackedOpenState.closed) {
                        delete newQuery[__props.filterKey];
                    }
                    else {
                        newQuery = {
                            ...newQuery,
                            ...{
                                [__props.filterKey]: __props.multiple
                                    ? selectedOptions.value?.map(({ key }) => key)
                                    : selectedOptions.value?.key,
                            },
                        };
                    }
                    if (__props.pagination && route.query.startIndex > 1) {
                        newQuery = {
                            ...newQuery,
                            ...{
                                startIndex: 1,
                            },
                        };
                    }
                    router.push({
                        query: newQuery,
                    });
                }
                else {
                    query.value = '';
                }
            }
        }
        function updateSelectedOptions() {
            const queryOptions = asArray(route.query[__props.filterKey]);
            let newSelectedOptions = options.value.filter(({ key }) => queryOptions.includes(key));
            if (newSelectedOptions.length === 0 && __props.defaultValue) {
                if (Array.isArray(__props.defaultValue)) {
                    newSelectedOptions = __props.defaultValue;
                }
                else {
                    newSelectedOptions = [__props.defaultValue];
                }
            }
            if (__props.multiple) {
                selectedOptions.value = newSelectedOptions;
            }
            else {
                selectedOptions.value = newSelectedOptions[0];
            }
        }
        const selectedOptions = ref(null);
        watch(() => [route.query, __props.filterOptions], () => {
            updateSelectedOptions();
        }, { immediate: true });
        updateSelectedOptions();
        const __returned__ = { $t, route, router, options, query, onInput, filteredOptions, filteredDebouncedOptions, get debounceInterval() { return debounceInterval; }, set debounceInterval(v) { debounceInterval = v; }, get limit() { return limit; }, set limit(v) { limit = v; }, isOpen, trackedOpenState, trackOpenState, updateSelectedOptions, selectedOptions, get Combobox() { return Combobox; }, get ComboboxButton() { return ComboboxButton; }, get ComboboxInput() { return ComboboxInput; }, get ComboboxOption() { return ComboboxOption; }, get ComboboxOptions() { return ComboboxOptions; }, get ChevronDownIcon() { return ChevronDownIcon; }, get MagnifyingGlassIcon() { return MagnifyingGlassIcon; }, get XMarkIcon() { return XMarkIcon; } };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
